// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__aUUvi","notes":"Notes_notes__2ACBA"};